<template>
  <Transition name="fade" class="delay-600">
    <aside
      v-if="visible && $content.options?.value?.popup"
      class="fixed top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.6)] z-200 p-10 flex items-center justify-center"
    >
      <div
        class="relative p-10 flex justify-between items-center flex-col h-full max-h-full max-w-full aspect-square lg:h-full"
      >
        <ResponsiveImage
          v-if="$content.options?.value?.popup?.image"
          :media="$content.options?.value?.popup?.image"
          class="absolute top-0 left-0 w-full h-full object-cover"
        />
        <div class="relative text-center">
          <h2
            v-if="$content.options.value.popup.title"
            class="font-title text-white uppercase mb-4 text-5xl md:text-7xl"
          >
            {{ $content.options.value.popup.title }}
          </h2>
          <h3
            v-if="$content.options.value.popup.subtitle"
            class="font-title text-white text-xl md:text-2xl"
          >
            {{ $content.options.value.popup.subtitle }}
          </h3>
        </div>
        <div class="relative text-center">
          <a
            v-if="
              $content.options.value.popup.button.link && $content.options.value.popup.button.label
            "
            :href="$content.options.value.popup.button.link"
            target="_blank"
            class="button mb-4"
          >
            {{ $content.options.value.popup.button.label }}
          </a>
          <p v-if="$content.options.value.popup.note" class="text-white">
            {{ $content.options.value.popup.note }}
          </p>
        </div>
        <button
          class="absolute top-2 right-2 w-11 aspect-square border-white border-1 rounded-full text-white cursor-pointer"
          @click.stop="close"
        >
          <IconSprite id="close" />
        </button>
      </div>
    </aside>
  </Transition>
</template>

<script lang="ts">
import IconSprite from '@/components/helpers/IconSprite.vue'
import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'

export default {
  name: 'Popup',
  components: { IconSprite, ResponsiveImage },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    close() {
      this.visible = false
    },
  },
  watch: {
    '$content.options.value.popup'(newVal) {
      if (!newVal) return

      const start = new Date(newVal.publish.start)
      const end = new Date(newVal.publish.end)
      const now = new Date()

      this.visible = start < now && end > now
    },
  },
}
</script>
